module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tagKeyValueManageMenu.editSpendLimit":"Set Spend Limit","tagKeyValueManageMenu.promoteToDimension":"Promote to Dimension!","tagKeyValueManageMenu.demoteToTagKey":"Demote to Tag Key!"}}')
  delete Component.options._Ctor
}
